export default "__VITE_ASSET__ea6bd5ef__"